import { useApplicationCallbacks } from '../../../../../providers/application-callbacks';
import { useEffect } from 'react';
import { useRequestsHandlerData } from '../../../../../hooks/useRequestsHandlerData';

export default function useGetProductsAndClear() {
  const { getWebCatalogProductsBySku, getWebCatalogProductsBySkuBeautyRoutine, resetProductsFromGA } =
    useApplicationCallbacks();

  useEffect(() => resetProductsFromGA, []);

  const isPending = useRequestsHandlerData([{ address: 'requestsGetWebCatalogProductsBySkuBeautyRoutine' }]);

  return [
    (skus, isBeautyRoutine = false) => {
      if (isBeautyRoutine) {
        return getWebCatalogProductsBySkuBeautyRoutine(skus);
      }

      return getWebCatalogProductsBySku(skus);
    },
    isPending,
  ];
}
